<div class="impersonate-component">
  @if (true) {
    <lib-loader class="main-loader" [message]="message"></lib-loader>
  }
</div>
